import { BusinessCategoryDTO } from '../types/company'
import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'CompanyService'
const host = servicesConfig.Companies
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const CompanyService = {
  read: (id: string) => request().get(`/${id}`).then(responseBody),

  update: (id: string, data: { [key: string]: any }) => request().put(`/${id}`, data).then(responseBody),

  updateReselling: (id: string, data: { [key: string]: any }) =>
    request().put(`/${id}/update-reselling`, data).then(responseBody),

  addBusinessCategory: (companyId: string, data: BusinessCategoryDTO) =>
    request().put(`/${companyId}`, data).then(responseBody),

  getBranding: (domain: string) => request().get(`/branding?domain=${domain}`).then(responseBody),
  acceptTnc: (companyId: string, userId: string, tncVersion: string) =>
    request()
      .post(`agency-tnc-acceptance`, { companyId, acceptedBy: userId, tncVersion: tncVersion, acceptedAt: new Date() })
      .then(responseBody),

  Lab: {
    addFeedback: (companyId: string, body: { [key: string]: any }) =>
      request().post(`/${companyId}/labs/feedbacks`, body).then(responseBody),

    getFeatureFlags: (companyId: string) => request().get(`/${companyId}/labs/featureFlags`).then(responseBody),

    upsertFeatureFlag: (companyId: string, body: { [key: string]: any }) =>
      request().put(`/${companyId}/labs/featureFlags`, body).then(responseBody),
  },
}

export default CompanyService
